module.exports = __webpack_public_path__ + "b460b48967e1e345c90dba0a1fbf07bc.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/img/sprite_benefits_clock.png
// module id = 288
// module chunks = 0